import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { ColumnConfiguration } from 'common/components/ConfigurableTable/models/configurableTable.ts';

export const useProductManagementColumnConfiguration = () => {
  const { t } = useTranslation();

  return useMemo(() => {
    const configuration: ColumnConfiguration[] = [
      {
        field: 'fileName',
        headerName: t('common.fileName'),
        resizable: false,
        sortable: false,
        pinnable: false,
        minWidth: 350,
      },
      {
        field: 'status',
        headerName: t('common.status'),
        resizable: false,
        sortable: false,
        pinnable: false,
        width: 246,
      },
      {
        field: 'numberOfCards',
        headerName: t('activityLog.productsManagement.table.headers.numberOdProducts'),
        resizable: false,
        sortable: false,
        pinnable: false,
        minWidth: 128,
      },
      {
        field: 'numberOfSuccessCards',
        headerName: t('common.success'),
        resizable: false,
        sortable: false,
        pinnable: false,
      },
      {
        field: 'numberOfFailedCards',
        headerName: t('common.failed'),
        resizable: false,
        sortable: false,
        pinnable: false,
      },
      {
        field: 'uploadAt',
        headerName: t('common.uploadTime'),
        resizable: false,
        sortable: false,
        pinnable: false,
        minWidth: 196,
      },
      {
        field: 'uploadFinishedAt',
        headerName: t('bulkProvisioning.processingFinishedTime'),
        resizable: false,
        sortable: false,
        pinnable: false,
        minWidth: 196,
      },
      {
        field: 'uploadBy',
        headerName: t('simInventory.userName'),
        resizable: false,
        sortable: false,
        pinnable: false,
        minWidth: 120,
        flex: 1,
      },
      {
        field: 'id',
        headerName: t('common.id'),
        resizable: false,
        sortable: false,
        pinnable: false,
        minWidth: 350,
      },
    ];
    return configuration;
  }, [t]);
};
